import { Box, Typography, useTheme ,Stack,Button,IconButton} from "@mui/material";
import { GridColumns,
  GridCellParams,
  GridRowsProp,
  DataGrid,
  GridCellModesModel,
  GridCellModes} from "@mui/x-data-grid";
import { tokens } from "../../../theme";
import Header from "../../../components/global/Header";
import React, { useState, useEffect,useMemo } from 'react';
import NiceDate from "../../../components/global/NiceDate";
import { useDispatch, useSelector } from "react-redux";
import { getUsers , updateUser} from "../../../slices/user";
import { setMessage , clearMessage} from "../../../slices/message"
import DeleteIcon from '@mui/icons-material/Delete';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import { Link, useNavigate } from "react-router-dom";
import InfoIcon from '@mui/icons-material/Info';
import NiceCollection from "../../../components/global/NiceCollection";

const UserList = () => {
  const navigate = useNavigate();

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const dispatch = useDispatch();

  const users = useSelector((state) => state.user.users);

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);


  useEffect(() => {
    dispatch(getUsers({"page":page,"pagesize":pageSize}));

}, [page,pageSize]);

const processRowUpdate = React.useCallback(
  async (newRow) => {
    // Make the HTTP request to save in the backend
    //debugger
    const id = newRow.id;
    const isBlocked = newRow.isBlocked;

    //dispatch(updateSession({id,isBlocked}));

    return newRow;
  },
  [users],
);

const handleRowClick = (params) => {
  navigate("/user/" + params.id);
};

const handleProcessRowUpdateError = React.useCallback((error) => {
  

  dispatch(setMessage("Error editing user"));
}, []);


  const columns = [
    { 
      field: "collection", 
      headerName: "Collection" ,
      flex: 1,
      renderCell: ({row: {collection}}) => {

        return (
          <NiceCollection>{collection}</NiceCollection>
        )
      }
    },
    { 
      field: "username", 
      headerName: "User" ,
      flex: 1
    },
    { 
      field: "full_name", 
      headerName: "Full Name" ,
      flex: 1,
      renderCell: ({row: {firstName,lastName}}) => {

        return (
          <Typography>
            {firstName} {lastName}
          </Typography>
        )
      }
    },
    { 
      field: "email", 
      headerName: "Email" ,
      flex: 1,
    },
    {
      field: "active",
      headerName: "Active",
      type:"boolean",
      editable: true ,
      renderCell: ({row: {active}}) => {

        return (
          <Box>
          {active &&
            <CheckIcon />
          }
          </Box>
        )
      }

    },
    {
      field: "createdAt",
      headerName: "Created",
      flex: 1,  
      renderCell: ({row: {createdAt}}) => {

        return (
          <NiceDate>{createdAt}</NiceDate>
        )
      }
    },
    {
      headerName: "Actions",
      field:"",
      flex: 1,
      type:"actions",
      disableClickEventBubbling: true,

      
      renderCell: (params) => {
          const handleUnBlock = (e) => {
            e.stopPropagation();
            dispatch(clearMessage());
            const currentRow = params.row;
            const username = currentRow.username;
            
            const user = {
              username: username,
              active: true,
            }

            dispatch(updateUser({user}));

          };

          const handleBlock = (e) => {
            e.stopPropagation();
            dispatch(clearMessage());
            const currentRow = params.row;
            const username = currentRow.username;
            
            const user = {
              username: username,
              active: false,
            }

            dispatch(updateUser({user}));

          };

          const handleDelete = (e) => {
            e.stopPropagation();
            dispatch(clearMessage());
            const currentRow = params.row;
            const username = currentRow.username;

            //dispatch(updateSession({id,isBlocked}));

          };

          const handleEdit= (e) => {
            e.stopPropagation();
            dispatch(clearMessage());
            const currentRow = params.row;
            const username = currentRow.username;

            navigate("/user/" + username);

          };

          

          return (
            
            <Stack key={"STACK-" + params.row.username}  direction="row" spacing={2}>

              {!params.row.active ?
              <IconButton key={"UNLOCK-" + params.row.username} aria-label="unblock" onClick={handleUnBlock}>
                <LockOpenIcon />
              </IconButton>
              :
              <IconButton key={"LOCK-" + params.row.username}  aria-label="block" onClick={handleBlock}>
                <LockIcon />
              </IconButton>
      }

              <IconButton key={"EDIT-" + params.row.username} aria-label="delete" onClick={handleEdit}>
                <InfoIcon />
              </IconButton>

              <IconButton key={"DELETE-" + params.row.username} aria-label="delete" onClick={handleDelete} disabled>
                <DeleteIcon />
              </IconButton>

            </Stack>
          );
      },
    },

  ];

  return (

    <Box m="20px">

      <Header title="User List" subtitle="List of users" />

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >

          <DataGrid  experimentalFeatures={{newEditingApi: true }}
          onRowClick={handleRowClick}
          getRowId={(row) => row.username}
            processRowUpdate={processRowUpdate}
            onProcessRowUpdateError={handleProcessRowUpdateError}
            rows={users.data.list} 
            columns={columns} 
            pageSize={pageSize}
            page={users.data.page}
            rowsPerPageOptions={[10, 25,50,100]}
            paginationMode="server"
            rowCount={users.data.total}
            onPageChange={(newPage) => setPage(newPage)}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          />    

      </Box>
    </Box>
  );
};

export default UserList;
